import { AnimatePresence, motion } from "motion/react";
import React from "react";

interface CardListProps<T> {
  items: T[];
  renderItem: (item: T, index: number) => React.ReactNode;
  itemKeyFn: (item: T) => string | number;
}

export function AnimatedList<T>({ items, renderItem, itemKeyFn }: CardListProps<T>) {
  const getPageKey = () => {
    return items.map(itemKeyFn).join("-");
  };

  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
        key={getPageKey()}
        className="flex flex-col space-y-2"
      >
        {items.map((item, index) => (
          <motion.div
            key={itemKeyFn(item)}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.3,
              delay: index * 0.05,
              ease: [0, 0.71, 0.2, 1.01]
            }}
          >
            {renderItem(item, index)}
          </motion.div>
        ))}
      </motion.div>
    </AnimatePresence>
  );
}
